import { useAuth } from 'context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';
import { UserRole } from 'shared/constants';

export const SitterGuard = () => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user?.roles.includes(UserRole.SITTER)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};
